import React from "react";
import "./App.css";
import NavBarLayout from "./NavbarLayout";
import { iconColor } from "./colors";
import IconButton from "@mui/material/IconButton";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward, IoMdHeart } from "react-icons/io";
import { FaComment } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { CgProfile } from "react-icons/cg";

import Outfit from "./outfits/outfit 1.png";
import CommentSection from "./CommentSection";
import {
  getIndexFromUsername,
  getRandomEvent,
  getRandomLocalUser,
  getRandomNumber,
  getRandomOutfit,
} from "./Data";

function FriendsCard(props) {
  const [commentsOpen, setCommentsOpen] = React.useState(false);
  const { username, pfp } = props;
  const [showLeft, setShowLeft] = React.useState(false);
  const [showRight, setShowRight] = React.useState(true);
  const navigate = useNavigate();
  const scrollRef = React.useRef();
  const timeoutRef = React.useRef();

  const dataKey = "friends_feed_" + username;
  const numComments = getRandomNumber("comments" + dataKey, 5, 30);
  const numLikes = getRandomNumber("likes" + dataKey, 20, 100);
  const numOutfits = props.isChoose
    ? getRandomNumber("outfits" + dataKey, 2, 4)
    : getRandomNumber("outfits_ootd" + dataKey, 1, 1);
  const outfits = props.isChoose
    ? getRandomOutfit(dataKey, numOutfits)
    : getRandomOutfit("outfits_ootd" + dataKey, numOutfits);

  const handleScroll = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      const scroll = scrollRef.current;
      const width = window.innerWidth;
      const x = Math.round(scroll.scrollLeft / width) * width;

      scroll.scroll({ left: x, behavior: "smooth" });

      setShowLeft(x !== 0);
      setShowRight(scroll.offsetWidth + x < scroll.scrollWidth);
    }, 100);
  };

  const scrollDelta = (delta) => {
    const scroll = scrollRef.current;
    const width = window.innerWidth;
    const x = (Math.round(scroll.scrollLeft / width) + delta) * width;

    scroll.scroll({ left: x, behavior: "smooth" });

    setShowLeft(x !== 0);
  };

  return (
    <div className="FriendsCard-container">
      <div
        onClick={() =>
          navigate(`/friend?user=${getIndexFromUsername(username)}}`)
        }
        className="FriendsCard-upperBar"
      >
        <img className="FriendsCard-pfp" src={pfp} alt=""></img>
        <div>{username}</div>
      </div>
      <div
        onScroll={handleScroll}
        ref={scrollRef}
        className="FriendsCard-hScroll"
      >
        {outfits.map((outfit) => (
          <div key={outfit} className="FriendsCard-imageContainer">
            <img className="FriendsCard-image" src={outfit}></img>
          </div>
        ))}
      </div>
      <div className="FriendsCard-description">
        {props.isChoose ? getRandomEvent(username, 1)[0] : "Today's OOTD"}
      </div>
      {props.isChoose && (
        <>
          <div className="FriendsCard-buttons">
            <IoMdHeart size="2rem" color="#636291" />
            <div>{numLikes}</div>
            <FaComment
              onClick={() => setCommentsOpen(true)}
              size="1.75rem"
              color="#636291"
            />
            <div>{numComments}</div>
          </div>
          {showLeft && (
            <div
              onClick={() => scrollDelta(-1)}
              className="FriendsCard-arrowBack"
            >
              <IoIosArrowBack size="2.5rem" />
            </div>
          )}
          {showRight && (
            <div
              onClick={() => scrollDelta(1)}
              className="FriendsCard-arrowForward"
            >
              <IoIosArrowForward size="2.5rem" />
            </div>
          )}
        </>
      )}
      <CommentSection
        dataKey={dataKey}
        numComments={numComments}
        open={commentsOpen}
        setOpen={setCommentsOpen}
      />
    </div>
  );
}

function FriendsFeed() {
  const [activeTab, setActivetab] = React.useState(0);
  const navigate = useNavigate();

  const numLocalUsers = getRandomNumber("friendsfeed", 3, 5);
  const localUsers = getRandomLocalUser("friendsfeed", numLocalUsers);

  return (
    <NavBarLayout
      title="Friends"
      onBackButtonClicked={() => navigate("/home")}
      rightIcon={
        <IconButton onClick={() => navigate("/friendssearch")}>
          <IoSearch size="2.5rem" color={iconColor} />
        </IconButton>
      }
      active={2}
    >
      <div className="FriendsFeed-container">
        <div className="FriendsFeed-upperBar">
          <div
            onClick={() => setActivetab(0)}
            className={`FriendsFeed-tab ${
              activeTab === 0 ? "FriendsFeed-tabActive" : ""
            }`}
          >
            #OOTDs
          </div>
          <div
            onClick={() => setActivetab(1)}
            className={`FriendsFeed-tab ${
              activeTab === 1 ? "FriendsFeed-tabActive" : ""
            }`}
          >
            Choose
          </div>
        </div>
        <div className="FriendsFeed-mainScrollContainer">
          <div className="FriendsFeed-mainScroll">
            {localUsers.map((localUser) => (
              <FriendsCard
                key={localUser.username}
                isChoose={activeTab === 1}
                {...localUser}
              />
            ))}
          </div>
        </div>
      </div>
    </NavBarLayout>
  );
}

export default FriendsFeed;
